module.exports = __webpack_public_path__ + "static/media/agriculture.4c3afd6f.png";